"use client";

import { useMixpanel } from "@/hooks/mixpanel/use-mixpanel";

export const useRecordAudioTracking = () => {
  const { track } = useMixpanel();

  const trackRecordAudio = (recordingTime: any) => {
    track("Audio Recorded Tracking", {
      duration: recordingTime,
    });
  };

  return {
    trackRecordAudio,
  };
};
